import { render, staticRenderFns } from "./DynamicImageIcon.vue?vue&type=template&id=feada12a&"
import script from "./DynamicImageIcon.vue?vue&type=script&lang=ts&"
export * from "./DynamicImageIcon.vue?vue&type=script&lang=ts&"
import style0 from "./DynamicImageIcon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports